import React from 'react';
import { useLang } from '../../_LangContext';
import { mergeClasses } from '@griffel/react';

const TabBarItem = ({ id, className, iconClass, localeKey, onClick, isActive }) =>
{
    const { getText } = useLang();

    return (
        <div 
            className={mergeClasses('tab-bar-item', className, isActive ? 'active' : '')} 
            data-id={id} 
            onClick={() => onClick(id)}
        >
            <div className="item-label">
                <p className={`icon ${iconClass}`} />
                <div className="text">{getText(localeKey)}</div>
            </div>
        </div>
    );
};

const TabBarItems = ({ className, items, onClick, activePageID }) =>
{
    return (
        <div className={mergeClasses('tab-bar-items', className)}>
            {items.map(item => (
                <TabBarItem
                    key={item.id}
                    id={item.id}
                    className={item.className}
                    iconClass={item.iconClass}
                    localeKey={item.localeKey}
                    onClick={onClick}
                    isActive={item.id === activePageID}
                />
            ))}
        </div>
    );
};

export { TabBarItem, TabBarItems }; 